import store from '@/store'
import ls from 'local-storage'
export default function guards (to, from, next) {
  const user = ls.get('ot-user')

  // check if logged in
  if (to.matched.some(record => record.meta.protected) && !user) {
  // if no user in local storage, call API to check whether or not they are actually logged in
    if (to.path !== '/' && to.path !== '/login') {
      // ls.set('previousPath', to.path)
    }
    store.dispatch('profile/getProfileUser').then(() => {
      const loggedInUser = store.state.profile.user
      ls.set('ot-user', loggedInUser)
      // if not logged in redirect to login
      if (!loggedInUser) {
        ls.remove('ot-user')
        next({path: '/login', redirect: '/login'})
      } else {
        if (ls.get('previousPath')) {
          next({path: '/'})
          // next({path: ls.get('previousPath')})
        } else {
          next({path: '/'})
        }
      }
    }, () => {
      ls.remove('ot-user')
      next({path: '/login', redirect: '/login'})
    })
  }
  const isAdmin = user && user.role === 1 // is admin user
  const isClientAdmin = user && user.role === 4 // is client admin user
  // const isClient = user && user.role === 6 // is client user

  // check authorisation for logged in users
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (isAdmin || isClientAdmin) {
      next()
    } else {
      next({path: '/'})
    }
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/guards.js